import { Component, Input, OnInit } from '@angular/core';
import { TaskPriorityEnumValues } from '../../../models/surveys-tasks/enums/TaskPriorityEnumValues';
import { Priority } from '../../../models/surveys-tasks/SurveyTaskDetails';

@Component({
  selector: 'app-survey-tasks-priority',
  standalone: false,
  templateUrl: './survey-tasks-priority.component.html'
})
export class SurveyTasksPriorityComponent implements OnInit {

  @Input({ required: true }) priority: Priority;
  priorityEnum = TaskPriorityEnumValues;

  constructor() { }

  ngOnInit() {
  }
}
